<template>
  <div class="carousel">
    <el-button type="primary" @click="addImage" size="mini"
      >新增轮播图</el-button
    >

    <!-- <el-button @click="resetForm('ruleForm')" size="small">重置</el-button> -->

    <div class="table-style">
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column prop="created_time" label="创建时间"></el-table-column>

        <el-table-column prop="id" label="缩略图">
          <template slot-scope="scope">
            <el-image
              style="width: 150px; height: 60px"
              :src="scope.row.img_url"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="content" label="文本内容"> </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="updateImages(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="danger" @click="deleteImage(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="新增轮播图" :visible.sync="dialogVisible" width="800px">
      <el-form
        class="form-style"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="200px"
        label-position="right"
      >
        <el-form-item label="选择图片" required prop="fileList">
          <el-upload
            action=""
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChangeFile"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="form.fileList"
            list-type="picture"
            style="width: 400px"
          >
            <el-button size="mini" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="文本内容" prop="content">
          <el-input v-model="form.content"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('form')" size="small"
          >保存</el-button
        >
        <el-button @click="quitDialog('form')" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminAddOrUpdateSchoolBanner,
  adminGetSchoolBannerList,
  adminDeleteSchoolBanner,
} from '@/api/admin'

import uploadFile from '@/config/uploadFile'

export default {
  name: 'community-set',
  props: {
    homepageBanner: Array,
    homepage_id: Number,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }
    return {
      imageId: '',
      form: {
        content: '',
        fileList: [],
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        fileList: [{ validator: validatePass, trigger: 'change' }],
      },
      uploadFileTime: false,
    }
  },
  watch: {
    homepageBanner() {
      this.tableData = this.homepageBanner
    },
  },

  mounted() {
    this.adminGetSchoolBannerList()
  },

  methods: {
    adminGetSchoolBannerList() {
      adminGetSchoolBannerList({
        banner_type: 2,
      }).then((res) => {
        console.log('社区轮播图')
        console.log(res)
        this.tableData = res.bannerList
      })
    },

    addImage() {
      this.form.title_one = ''
      this.form.title_two = ''
      this.form.fileList = []
      this.form.content = ''
      this.imageId = ''
      this.dialogVisible = true
    },

    quitDialog(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    updateImages(row) {
      this.imageId = row.id
      this.form.content = row.content
      this.form.fileList = [
        {
          url: row.img_url,
          name: row.img_url.split('/')[row.img_url.split('/').length - 1],
        },
      ]
      this.dialogVisible = true
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.imageId) {
            adminAddOrUpdateSchoolBanner({
              id: this.imageId,
              img_url: this.form.fileList[0].url,
              banner_type: 2,
              content: this.form.content,
            }).then((res) => {
              if (res.is_update) {
                this.$message.success('更新轮播图成功!')
                this.adminGetSchoolBannerList()
                this.dialogVisible = false
              }
            })
          } else {
            adminAddOrUpdateSchoolBanner({
              img_url: this.form.fileList[0].url,
              banner_type: 2,
              content: this.form.content,
            }).then((res) => {
              if (res.is_create) {
                this.$message.success('上传轮播图成功！')
                this.adminGetSchoolBannerList()
                this.dialogVisible = false
              }
            })
          }
        }
      })
    },
    uploadFile() {},
    handleRemove(file, fileList) {
      this.form.fileList = fileList
    },

    handleExceed() {
      this.$message.warning(`只能上传1张图片，请删除后重新上传！`)
    },

    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form.fileList = res
          this.uploadFileTime = false
        }
      )
    },
    deleteImage(row) {
      this.$confirm('确定删除本条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        adminDeleteSchoolBanner({
          id: row.id,
        }).then((res) => {
          if (res.is_delete) {
            this.$message.success('删除成功！')
            this.adminGetSchoolBannerList()
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.carousel {
  height: 100%;
  background-color: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;

  .table-style {
    margin-top: 20px;
    padding-bottom: 20px;
  }
}
</style>
